










import Vue from 'vue'
import { mapGetters, mapState } from 'vuex'

import SensitivitySelect from '@/components/Select/Sensitivity.vue'
import { IStateThing } from '@/store/modules/thing'

export default Vue.extend({
  components: {
    SensitivitySelect
  },
  computed: {
    ...mapState<IStateThing>('thing', {
      serial: (state: IStateThing) => state.serial
    }),
    ...mapGetters('thing', ['sensitivityMatch'])
  }
})
